import React from 'react'
import FooterImage from '../../img/FooterImage.png'
import { Grid , Container} from '@material-ui/core'

export default () => (
    <footer>
        <Container maxWidth='lg'>
            <Grid container id='social-menu' alignContent='center' justify='center' spacing={5} direction='column'>
                <Grid item xs={12} className='text-center'>
                    <strong>ما را در شبکه های اجتماعی دنبال کنید</strong>
                </Grid>

                <Grid item xs={12} className='text-center'>
                    <a href="https://www.instagram.com/manam_idaas/">
                        <i className="fab fa-instagram"></i>
                    </a>
                    <a href="#">
                        <i className="fab fa-telegram"></i>
                    </a>
                    <a href="#">
                        <i className="fab fa-twitter"></i>
                    </a>
                    <a href="#">
                        <i className="fab fa-linkedin"></i>
                    </a>
                    <a href="#">
                        <i className="fab fa-youtube"></i>
                    </a>
                </Grid>
            </Grid>
        </Container>

        {/* <img src={FooterImage} alt='' /> */}
    </footer>
)